module.exports = __webpack_public_path__ + "img/image58.e38b2532.png";